<template>
  <a
    href="#main-content"
    class="sr-only focus:not-sr-only focus:fixed focus:start-3 focus:top-3 focus:z-[100] focus:rounded-md focus:bg-card focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
  >
    {{ $t("common.skipToContent") }}
  </a>
  <div
    class="grid min-h-dvh grid-cols-1 overflow-x-clip bg-background md:grid-cols-[264px_1fr]"
  >
    <div class="sticky top-0 hidden h-dvh md:block">
      <Sidebar />
    </div>
    <!-- min-h-0 + flex-1 on the last child: the slot fills the area below the topbar without squeezing it -->
    <div
      class="flex min-w-0 flex-col [&>:last-child]:min-h-0 [&>:last-child]:flex-auto"
    >
      <Navbar />
      <NotificationBanner />
      <!-- overflow-y-clip: a new page's 8px rise-in must not make the document taller -->
      <main
        id="main-content"
        tabindex="-1"
        class="flex min-w-0 flex-col overflow-y-clip outline-none [&>:last-child]:min-h-0 [&>:last-child]:flex-auto"
      >
        <slot />
      </main>
    </div>
  </div>
  <ProModal />
  <AuthModal />
  <Toaster richColors />
</template>

<script setup lang="ts">
import { Toaster } from "@/components/ui/sonner";
import { useUser } from "@/composables/useUser";

const { user, fetchUser } = useUser();

const { status } = useAsyncData('user', async () => {
  await fetchUser();
  return user.value;
});

</script>
